(() => {
  const configElement = document.querySelector('#nv-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const labels = config.labels;
  const localizedVariant = value => String(value || '').split(' / ').map(part => config.scents?.[part] || part).join(' / ');
  const productPhotos = JSON.parse(document.querySelector('#nv-product-photos')?.textContent || '{}');
  const root = `${(window.Shopify?.routes?.root || config.root || '/').replace(/\/$/, '')}/`;
  const drawer = document.querySelector('#nv-cart-drawer');
  const itemsElement = document.querySelector('[data-nv-drawer-items]');
  const announcement = document.querySelector('#nv-announcement');
  const errorElement = document.querySelector('.nv-drawer-error');
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const money = (amount, currency) => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: currency || config.currency, currencyDisplay: 'code' }).format(amount / 100);
  let queue = Promise.resolve();
  const enqueue = operation => {
    const result = queue.then(operation);
    queue = result.catch(() => {});
    return result;
  };
  const announce = message => { announcement.textContent = message; };
  const showError = message => {
    errorElement.textContent = message || labels.error;
    errorElement.hidden = false;
  };
  const request = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', ...options, headers: { Accept: 'application/json', ...options.headers } });
    let data;
    try { data = await response.json(); } catch { throw new Error(labels.error); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : labels.error);
    return data;
  };
  const localUrl = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin ? `${url.pathname}${url.search}` : config.cart; } catch { return config.cart; }
  };
  const singlePhoto = (source, format, scent, title) => {
    if (!source) return '';
    let url;
    try { url = new URL(source, location.origin); if (url.protocol !== 'https:' && url.origin !== location.origin) return ''; } catch { return ''; }
    const isolated = url.pathname.includes('naturova-natural-');
    return `<div class="nv-photo nv-photo--${format} nv-photo--front nv-photo--${scent}${isolated ? ` nv-photo--isolated nv-photo--${scent}-${format}` : ''}"><img class="nv-photo-image" src="${escape(url.href)}" alt="${escape(title)}" loading="lazy"></div>`;
  };
  const photo = item => {
    const path = item.url || '';
    const keys = ['ocean', 'mint-lemon', 'eucalyptus', 'tea-tree'];
    const names = ['Ocean Fresh', 'Mint & Lemon', 'Eucalyptus & Blossom', 'Tea Tree'];
    const isDuo = path.includes('daily-duo');
    const isRollEdit = path.includes('roll-on-edit');
    const isSprayEdit = path.includes('spray-edit');
    const isComplete = path.includes('complete-collection');
    if ((isDuo || isRollEdit || isSprayEdit || isComplete) && productPhotos.spray?.length === 4 && productPhotos['roll-on']?.length === 4) {
      let entries;
      if (isDuo) {
        const skuParts = (item.sku || '').split('-');
        const codes = ['OC', 'ML', 'EB', 'TT'];
        const chosen = codes.includes(skuParts[2]) && codes.includes(skuParts[3]) ? [names[codes.indexOf(skuParts[2])], names[codes.indexOf(skuParts[3])]] : (item.variant_title || '').split(' / ');
        entries = [['spray', Math.max(0, names.indexOf(chosen[1]))], ['roll-on', Math.max(0, names.indexOf(chosen[0]))]];
      } else {
        entries = keys.map((_, index) => [isRollEdit ? 'roll-on' : 'spray', index]);
        if (isComplete) entries.push(...keys.map((_, index) => ['roll-on', index]));
      }
      return `<div class="nv-cart-bundle-photo${isComplete ? ' nv-cart-bundle-photo--complete' : ''}">${entries.map(([format,index]) => singlePhoto(productPhotos[format][index], format, keys[index], item.product_title)).join('')}</div>`;
    }
    if (!item.image) return '';
    const format = path.includes('roll-on') ? 'roll-on' : 'spray';
    const scent = path.includes('mint-lemon') ? 'mint-lemon' : path.includes('eucalyptus') ? 'eucalyptus' : path.includes('tea-tree') ? 'tea-tree' : 'ocean';
    return singlePhoto(item.image, format, scent, item.product_title);
  };
  const renderCart = cart => {
    errorElement.hidden = true;
    document.querySelectorAll('[data-nv-cart-count]').forEach(element => { element.textContent = String(cart.item_count); });
    document.querySelector('[data-nv-drawer-total]').textContent = money(cart.total_price, cart.currency);
    if (!cart.items.length) {
      itemsElement.innerHTML = `<div class="nv-drawer-empty"><h3>${escape(labels.empty)}</h3><p>${escape(labels.empty_text)}</p></div>`;
      return;
    }
    itemsElement.innerHTML = cart.items.map(item => `<article class="nv-drawer-line"><a class="nv-drawer-photo" href="${escape(localUrl(item.url))}">${photo(item)}</a><div><a href="${escape(localUrl(item.url))}"><h3>${escape(item.product_title.replace(/^NATUROVA\s+/, ''))}</h3></a>${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escape(localizedVariant(item.variant_title))}</p>` : ''}<div class="nv-drawer-line-total"><div class="nv-drawer-quantity" aria-label="${escape(labels.quantity)}"><button type="button" data-nv-change="${escape(item.key)}" data-quantity="${item.quantity - 1}" aria-label="${escape(labels.quantity)} −">−</button><span>${item.quantity}</span><button type="button" data-nv-change="${escape(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${escape(labels.quantity)} +"${item.quantity >= 99 ? ' disabled' : ''}>+</button></div><span>${escape(money(item.final_line_price, cart.currency))}</span></div><button type="button" class="nv-drawer-remove" data-nv-change="${escape(item.key)}" data-quantity="0">${escape(labels.remove)}</button></div></article>`).join('');
  };
  const refreshCart = async () => { const cart = await request(`${root}cart.js`); renderCart(cart); return cart; };
  const openDrawer = () => {
    if (!drawer || typeof drawer.showModal !== 'function') { location.assign(config.cart); return false; }
    if (!drawer.open) drawer.showModal();
    return true;
  };
  document.querySelectorAll('[data-nv-open-bag]').forEach(link => link.addEventListener('click', async event => {
    if (!drawer || typeof drawer.showModal !== 'function') return;
    event.preventDefault();
    openDrawer();
    try { await enqueue(refreshCart); } catch (error) { showError(error.message); }
  }));
  document.querySelectorAll('[data-nv-close-bag]').forEach(button => button.addEventListener('click', () => drawer.close()));
  drawer?.addEventListener('click', event => {
    const box = drawer.getBoundingClientRect();
    if (event.target === drawer && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) drawer.close();
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.nv-add-form');
    if (!form) return;
    if (config.catalogOnly) {
      event.preventDefault();
      announce(labels.coming_soon);
      return;
    }
    if (!form.checkValidity()) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('[type="submit"]');
    const formError = form.querySelector('.nv-form-error');
    if (button.disabled) return;
    const prior = button.innerHTML;
    const body = new FormData(form);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (form.classList.contains('nv-bundle-form') || form.classList.contains('nv-product-form')) button.textContent = labels.adding;
    if (formError) formError.hidden = true;
    try {
      await enqueue(async () => {
        await request(`${config.add}.js`, { method: 'POST', body });
        await refreshCart();
      });
      announce(labels.added);
      openDrawer();
    } catch (error) {
      if (formError) { formError.textContent = error.message; formError.hidden = false; }
      announce(error.message);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = prior;
    }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-nv-change]');
    if (!button || button.disabled) return;
    const quantity = Number(button.dataset.quantity);
    if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 99) return;
    const line = button.closest('.nv-drawer-line');
    line.querySelectorAll('button').forEach(control => { control.disabled = true; });
    try {
      await enqueue(async () => {
        const cart = await request(`${config.change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: button.dataset.nvChange, quantity }) });
        renderCart(cart);
      });
      announce(labels.updated);
    } catch (error) {
      showError(error.message);
      line.querySelectorAll('button').forEach(control => { control.disabled = false; });
    }
  });
  document.querySelectorAll('[data-nv-catalog]').forEach(catalog => {
    let format = 'all';
    let scent = 'all';
    const filter = () => {
      let count = 0;
      catalog.querySelectorAll('[data-nv-product]').forEach(card => {
        const visible = (format === 'all' || card.dataset.format === format) && (scent === 'all' || card.dataset.scent === scent);
        card.parentElement.hidden = !visible;
        if (visible) count += 1;
      });
      const counter = catalog.querySelector('[data-nv-count]');
      if (counter) counter.textContent = String(count);
    };
    catalog.querySelectorAll('[data-nv-filter]').forEach(button => button.addEventListener('click', () => {
      format = button.dataset.nvFilter;
      catalog.querySelectorAll('[data-nv-filter]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
      filter();
    }));
    catalog.querySelector('[data-nv-scent]')?.addEventListener('change', event => { scent = event.target.value; filter(); });
    filter();
  });
  document.querySelectorAll('[data-nv-gallery]').forEach(gallery => {
    gallery.querySelectorAll('[data-nv-gallery-view]').forEach(button => button.addEventListener('click', () => {
      gallery.querySelectorAll('[data-nv-gallery-panel]').forEach(panel => { panel.hidden = panel.dataset.nvGalleryPanel !== button.dataset.nvGalleryView; });
      gallery.querySelectorAll('[data-nv-gallery-view]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
    }));
  });
  document.querySelector('[data-nv-variant]')?.addEventListener('change', event => {
    const selected = event.target.selectedOptions[0];
    const price = document.querySelector('[data-nv-product-price]');
    if (price && selected.dataset.price) price.textContent = money(Number(selected.dataset.price));
  });
  document.querySelectorAll('[data-nv-duo-images]').forEach(source => {
    const visual = source.closest('.nv-bundle-visual');
    const scope = visual.closest('.nv-bundle') || visual.closest('.nv-pdp');
    const select = scope?.querySelector('select[name="id"]');
    if (!select) return;
    const images = JSON.parse(source.textContent);
    const scents = ['Ocean Fresh', 'Mint & Lemon', 'Eucalyptus & Blossom', 'Tea Tree'];
    const classes = ['ocean', 'mint-lemon', 'eucalyptus', 'tea-tree'];
    const update = () => {
      const picked = select.selectedOptions[0];
      const skuParts = (picked.dataset.nvSku || '').split('-');
      const codes = ['OC', 'ML', 'EB', 'TT'];
      const names = picked.textContent.trim().split(' / ');
      [['roll-on', names[0]], ['spray', names[1]]].forEach(([format, name]) => {
        const codeIndex = codes.indexOf(skuParts[format === 'spray' ? 3 : 2]);
        const index = codeIndex >= 0 ? codeIndex : scents.indexOf(name);
        const photo = visual.querySelector(`.nv-photo--${format}`);
        const image = photo?.querySelector('img');
        const formatImages = Array.isArray(images) ? images : images[format];
        if (index < 0 || !formatImages?.[index] || !image) return;
        classes.forEach(scent => { photo.classList.remove(`nv-photo--${scent}`); photo.classList.remove(`nv-photo--${scent}-${format}`); });
        photo.classList.add(`nv-photo--${classes[index]}`, 'nv-photo--isolated', `nv-photo--${classes[index]}-${format}`);
        image.removeAttribute('srcset');
        image.src = formatImages[index];
      });
    };
    select.addEventListener('change', update);
    update();
  });
  const menu = document.querySelector('[data-nv-menu]');
  const navigation = document.querySelector('#nv-navigation');
  const closeMenu = () => { menu?.setAttribute('aria-expanded', 'false'); navigation?.classList.remove('nv-navigation--open'); };
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    navigation.classList.toggle('nv-navigation--open', open);
  });
  navigation?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') { closeMenu(); menu.focus(); } });
  document.querySelector('[data-nv-language]')?.addEventListener('change', event => event.target.form.requestSubmit());
})();


